module.exports = __webpack_public_path__ + "static/media/strutture-luci-mobili-noleggiocampi.04e729ab.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/strutture/extra/luci/strutture-luci-mobili-noleggiocampi.jpg
// module id = 659
// module chunks = 0